import { render, staticRenderFns } from "./IncidentTypeForm.vue?vue&type=template&id=4c1392e0"
import script from "./IncidentTypeForm.vue?vue&type=script&lang=js"
export * from "./IncidentTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports